import React, { useState } from 'react';

// Form for entering Name and Email
export default function UserForm({ onCreate }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) return alert('Please enter both name and email');

    // Calls onCreate prop (provided by App) to send data to backend
    await onCreate({ name: name.trim(), email: email.trim() });

    // Clear form
    setName('');
    setEmail('');
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>
          Name:
          <input value={name} onChange={(e) => setName(e.target.value)} />
        </label>
      </div>
      <div style={{ marginTop: 8 }}>
        <label>
          Email:
          <input value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
      </div>
      <div style={{ marginTop: 10 }}>
        <button type="submit">Submit</button>
      </div>
    </form>
  );
}
